import React, { useEffect } from 'react';
import { useGlobalContext } from "../context/GlobalContext";

export const Typo = () => {
  const { setLightTheme, setNested } = useGlobalContext()

  useEffect(() => {
    setLightTheme(true);
    setNested(true)
  }, [])

  return (
    <React.Fragment>
      <div className="m-typo">
        <div className="m-typo__tab-container">
          <div className="m-typo__tab">
            <div className="m-typo__text">
              Typography for an album cover 'Bring Out Your Dead' by Cocktail Party Effect.
              </div>
            <img className="lazyload m-typo__cover" src={require('../static/images/graphics/typo/CPEcover.jpg')} alt="typography" />
          </div>
          <div className="m-typo__tab">
            <div className="m-typo__text">
              Typography for Stoka Ensemble! band.
              </div>
            <img className="lazyload m-typo__cover" src={require('../static/images/graphics/typo/stoka.png')} alt="typography" />
          </div>
          <div className="m-typo__tab">
            <div className="m-typo__text">
              Typography for Concert Practicum Musicae.
              </div>
            <img className="lazyload m-typo__cover" src={require('../static/images/graphics/typo/cpm.jpg')} alt="typography" />
          </div>

        </div>
      </div>
    </React.Fragment>
  )
}
